import {lazy} from 'react';

export const TableArchiveLazy = lazy(() => import(/* webpackChunkName: "tableArchive" */ '.'));
